module.exports = __webpack_public_path__ + "media/images/centre de fitness-048a44230a8a3331fbc7b31a8b6d10bf.svg";